import { EventTitleEnum, LanguageCodeEnum } from '../../../../../common/enums/common.enum';
import * as Yup from 'yup';
import { TFunction } from 'i18next';

const localizedTitleSchema = (requiredMsg: string) =>
  Yup.object().shape(
    Object.fromEntries(
      Object.values(LanguageCodeEnum).map(lang => [
        lang,
        lang === LanguageCodeEnum.ENG ? Yup.string().required(requiredMsg) : Yup.string().nullable()
      ])
    )
  );

/**
 * Built per call with the current `t`, not once at import: a schema made at module load
 * would freeze its messages in whatever language was active then, and keep them after a
 * switch.
 */
const eventConfigValidationSchema = (t: TFunction) =>
  Yup.object().shape({
    eventConfigs: Yup.object().shape(
      Object.fromEntries(
        Object.values(EventTitleEnum).map(mainEvent => [
          mainEvent,
          Yup.object().shape({
            childEvents: Yup.array().of(
              Yup.object().shape({
                title: localizedTitleSchema(t('events.validation.childEventNameRequired')),
                icon: Yup.string().test('icon-required', t('events.validation.toiletIconRequired'), function (value) {
                  if (mainEvent === EventTitleEnum.TOILET && !value) return false;
                  return true;
                })
              })
            ),
            options: Yup.array()
              .of(
                Yup.object().shape({
                  title: localizedTitleSchema(t('events.validation.optionTitleRequired')),
                  icon: Yup.string().test('icon-required', t('events.validation.optionIconRequired'), function (value) {
                    if (mainEvent !== EventTitleEnum.TOILET && !value) return false;
                    return true;
                  }),
                  value: Yup.number().required(t('events.validation.optionValueRequired'))
                })
              )
              .min(2, t('events.validation.atLeastTwoOptions'))
          })
        ])
      )
    )
  });

export const getStepSchemas = (singleGroupMode: boolean, t: TFunction) => {
  return [
    Yup.object({
      selectedGroups: singleGroupMode ? Yup.array().nullable() : Yup.array().min(1, t('events.validation.selectGroup')),
      selectedEvents: Yup.array().min(1, t('events.validation.selectEvent'))
    }),
    eventConfigValidationSchema(t),
    Yup.object()
  ];
};
